import React from 'react';
import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';
import {
	Login,
	Register,
	Workspace,
	ProjectDetail,
	DiagramEditor,
	Settings,
	Profile,
	SharePage,
} from './pages';
import {MainLayout} from './layout';
import {ProtectedRoute} from './ProtectedRoute';

const App: React.FC = () => {
	return (
		<BrowserRouter>
			<Routes>
				<Route path="/login" element={<Login />} />
				<Route path="/register" element={<Register />} />
				<Route path="/share/:token" element={<SharePage />} />
				<Route
					path="/projects/:id/diagrams/:diagramId"
					element={
						<ProtectedRoute>
							<DiagramEditor />
						</ProtectedRoute>
					}
				/>
				<Route
					path="/"
					element={
						<ProtectedRoute>
							<MainLayout />
						</ProtectedRoute>
					}
				>
					<Route index element={<Workspace />} />
					<Route path="projects/:id" element={<ProjectDetail />} />
					<Route path="profile" element={<Profile />} />
					<Route path="settings" element={<Settings />} />
				</Route>
				<Route path="*" element={<Navigate to="/" replace />} />
			</Routes>
		</BrowserRouter>
	);
};

export default App;
